import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { closeMenuItemAndGoToMenu } from 'bento-ordering/menus/actions/menuItem';
import MenuItemDetail from 'bento-ordering/menus/containers/MenuItemDetail';
import Modal from 'bento-ordering/base/ui_components/Modal';
import { WHITE } from 'bento-ordering/base/constants/colors';
import {
  getMenuItemImage,
  getMenuItem
} from 'bento-ordering/menus/reducers/menuItemsDetail';
import withGoogleLibraryLoaded from 'bento-ordering/base/hoc/withGoogleLibraryLoaded';

class MenuItemDetailModal extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    menuItemImage: PropTypes.string
  };

  render() {
    const { dispatch, menuItemImage } = this.props;
    const closeButtonColor = menuItemImage ? WHITE : '';
    return (
      <Modal
        closeButtonDataTestId="menu-item-detail-close"
        closeButtonColor={closeButtonColor}
        onClose={() => dispatch(closeMenuItemAndGoToMenu())}
      >
        <MenuItemDetail />
      </Modal>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { menuItemSlug } = ownProps.match.params;

  const menuItem = getMenuItem(state.menuItemsDetail, menuItemSlug);
  return {
    menuItemImage: getMenuItemImage(menuItem)
  };
};
export default withRouter(
  withGoogleLibraryLoaded(connect(mapStateToProps)(MenuItemDetailModal))
);
